<div class="modal-header">
  <h4 class="modal-title">
    @if (role === Role.enfant) {
      <span>{{
        "modales.addAccount.titleChild" | translate
      }}</span>
    }
    @if (role === Role.parent) {
      <span>{{
        "modales.addAccount.titleParent" | translate
      }}</span>
    }
  </h4>
</div>
<div class="modal-body">
  <div class="contentContainer">
    <form
      [formGroup]="createAccountForm"
      (ngSubmit)="validate()"
      class="createAddcountBlock"
      >
      <input
        type="text"
        id="peusdo"
                placeholder="{{
                    'addAccount.modale.nicknameInputPlaceholder' | translate
                }}"
        formControlName="pseudo"
        class="form-control"
        aria-label="Small"
        aria-describedby="inputGroup-sizing-sm"
        autocomplete="username"
        />
      <input
        type="password"
        id="password"
        [placeholder]="'common.labels.password' | translate"
        formControlName="password"
        class="form-control"
        aria-label="Small"
        aria-describedby="inputGroup-sizing-sm"
        autocomplete="new-password"
        />
      <input
        type="password"
        id="verifyPassword"
        [placeholder]="'auth.signup.confirmPassword' | translate"
        formControlName="verifyPassword"
        class="form-control"
        aria-label="Small"
        aria-describedby="inputGroup-sizing-sm"
        autocomplete="new-password"
        />
      <input
        type="text"
        id="lastname"
                placeholder="{{
                    'addAccount.modale.lastnameInputPlaceholder' | translate
                }}"
        formControlName="lastname"
        class="form-control"
        aria-label="Small"
        aria-describedby="inputGroup-sizing-sm"
        autocomplete="family-name"
        />
      <input
        type="text"
        id="firstname"
                placeholder="{{
                    'addAccount.modale.firstnameInputPlaceholder' | translate
                }}"
        formControlName="firstname"
        class="form-control"
        aria-label="Small"
        aria-describedby="inputGroup-sizing-sm"
        autocomplete="given-name"
        />
    </form>
  </div>
</div>
<div class="modal-footer">
  <button (click)="cancel()" type="button" class="btn btn-secondary">
    {{ "common.buttons.cancel" | translate }}
  </button>
  <button
    (click)="validate()"
    [disabled]="createAccountForm.invalid"
    type="button"
    class="btn btn-primary"
    >
    {{ "moduleCompletion.validate" | translate }}
  </button>
</div>
